import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import CommonTable from "utilFunctions/shared/CommonTable/CommonTable";

interface NotificationsTableIF {
  openFormHandler: any;
  setSelectedNotification: any;
  loader: boolean;
  data: any[];
  tableHeading: any;
  sortColumn: string;
  sortOrder: string;
  setSortColumn: any;
  setSortOrder: any;
  onEdit?: any;
  onDelete?: any;
  onView?: any;
}
const NotificationsTable = ({
  openFormHandler,
  setSelectedNotification,
  loader,
  data,
  tableHeading,
  sortColumn,
  sortOrder,
  setSortColumn,
  setSortOrder,
  onEdit,
  onDelete,
  onView,
}: NotificationsTableIF) => {
  const { screen }: any = useWindowSize();
  console.log(openFormHandler, setSelectedNotification);
  return (
    <>
      <CommonTable
        mode="notifications"
        isTableLoader={loader}
        tableData={data}
        tableHeading={tableHeading}
        sortColumn={sortColumn}
        sortOrder={sortOrder}
        setSortColumn={setSortColumn}
        setSortOrder={setSortOrder}
        primaryMessage="Data not found"
        secondaryMessage=""
        className={
          ["xs", "sm", "md"].includes(screen)
            ? "notificationTableMB"
            : "myBatchTable pr-0 pt-0"
        }
        sortingArray={["branchOrRegionName", "unmarkedLectureCount"]}
        onEdit={onEdit}
        onDelete={onDelete}
        onView={onView}
      />
    </>
  );
};
export default NotificationsTable;
